import { render } from "./BannerSavePartial.vue?vue&type=template&id=d24c7e3e"
import script from "./BannerSavePartial.vue?vue&type=script&lang=js"
export * from "./BannerSavePartial.vue?vue&type=script&lang=js"
script.render = render

export default script